/* bf26y-giftguard.js (13 Oct 2026, r16; r53 15 Oct 2026). Theme-side owner of the free wash bag and the free mystery gift lines. Loaded from snippets/bf26a-a11y.liquid (and as a fallback from assets/bf26y-autobag.js).
   Rules come from the ladder engine (snippets/bf26g-ladder-engine.liquid: tier string + gifts_count): the wash bag is earned at bagAt() paid pieces (3), the mystery gift at
   giftAt() (7) paid pieces (plus the wash bag only when gifts_count is true; the gift line never counts toward itself).
   1 /cart/add through fetch and XHR (JSON, FormData, URLSearchParams / urlencoded): bag or gift lines that are not earned (counting the cart and the same add) are dropped. If nothing is left the add is refused with a 422 and a small message. Adds that carry _bf_auto or _bf_free (the automatic adds) pass.
   2 wash-bag and mystery-gift product pages: submit and dynamic checkout buttons are disabled with 'Free with 3+ pieces' / 'Free with 7+ pieces' while not earned; the sticky add to cart bar is hidden then.
   3 r53 cart sync: the ONE code path that adds and removes the free lines (it replaces the bag add of bf26y-autobag.js, the gift add of bf26y-r12.js and the old clean-up here).
     - every cart request (fetch or XHR to /cart/add|change|update|clear) is tracked. 250 ms after the last one settles the cart is checked once (the engine's own read is
       reused when it is newer) and, only if needed, ONE update (unearned or extra free lines) and ONE add (bag and gift together) are posted with sections; the drawer
       is re-rendered from that response (Section Rendering API). The bag line shows well under a second after the 3rd piece lands (it used to take 4 to 5 s).
     - never a page reload. On /cart the cart sections (items, footer, rewards bar, header bubble) are re-rendered instead.
     - loop guards: response.ok and the JSON status are checked; a failed free add is retried at most twice per session (sessionStorage 'rk-gg-v1'); at most 20 sync posts per
       page; a free line the shopper removed by hand is not added back until the paid piece count changes.
     - when the drawer or the cart page shows an older cart than /cart.js (data-rk-cart-sig) it is re-rendered once for that cart (covers a second add the theme does not render).
       21 Oct 2026: 'once' is per cart request, not per page (the drawn-sig memo is cleared when a request settles). The sig is item_count.lines.total, so a later cart with
       the same sig as an earlier one (the 3-Pack Set after the 3-glove card in the cart suite, or A -> B -> A) was never re-rendered: drawer stuck on the old lines.
     - the Bundle Builder page manages its own perks (assets/bf26b2-cart.js): no sync posts there, only the request filter and the re-render check.
   window.RKCart = { render(sections), sync(), sectionIds() }: the one drawer / cart re-render helper (bf26g-gift-tip.js uses it).
   Known bypasses: native non-JS form posts, cart permalinks (/cart/<id>:1), checkout permalinks, Shopify Shop app / API calls, a customer who sets _bf_auto themselves in the console.
   Rollback: git revert of the r53 drawer commit (branch r53/drawer).
   r55 (FX1, 15 Oct 2026): the wash bag and the mystery gift are ALSO buyable at full price (Alexander). BUYABLE = true:
     - an add of a bag or gift is never refused or trimmed (1 above), and the wash-bag / mystery-gift product pages keep a normal Add to cart (2 above is off);
     - a BOUGHT line (no _bf_auto / _bf_free / _bf_set property) is never removed, trimmed or relabelled here, and counts 0 pieces (stateOf: bags and gifts
       are never pieces). Below the rung only the free lines are removed. From the rung a bought bag (or gift) IS the one bag the shopper gets: no free
       line is added next to it and an extra free line is trimmed (the r53 "the shopper's own line replaces the free line" rule), so the cart always holds
       the one bag the rung promises and Shopify's free-bag discount lands on it. Until the "Free Washbag" / "Free Mystery Gift" discounts become
       buy-X-get-Y at release, Shopify also makes a bought bag or gift free below the rung (known, release step).
     Shrine's quantity-break gift row no longer adds or removes the bag (snippets/quantity-breaks.liquid), so this file is the one bag and gift path.
     Rollback: BUYABLE = false brings back the r53 refusal and the locked product page buttons. */
(function () {
  'use strict';
  if (window.__bf26yGG || !window.fetch) return;
  window.__bf26yGG = 1;
  var BAG = 48000691962021, GIFT = 50544476749989;
  var of = window.fetch, path = location.pathname, handle = (path.match(/\/products\/([^\/?#]+)/) || [])[1];
  var ADD = /\/cart\/add(\.js)?(\?|$)/, MUT = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var BUILDER = /bundle-builder/.test(path);
  var QUIET = 250, MAX_POSTS = 20, MAX_FAIL = 2;
  var ALLOW_DECLINE = false; /* r55 (Alexander, 16 Oct 2026): free gifts cannot be declined; Shopify counts the bag and gift toward the tiers (hidden minimums 5/6/7/10 items), so a removed one is added back. true = a removed gift stays removed at that paid count. */
  var BUYABLE = false; /* HOTFIX 15 Oct 2026 ~23:55 Sydney (Alexander): gift pages NOT buyable until the gift discounts get a minimum (buy-X-get-Y did not stack with the family BXGYs; see Claude outputs/r55/RELEASE_2026-10-15b_rollback.md). true = buyable at full price. */
  function noop() {}
  function L() { return window.bf26gLadder; }
  function bagAt() { var l = L(); return (l && l.bagAt && l.bagAt()) || 3; }
  function giftAt() { var l = L(); return (l && l.giftAt && l.giftAt()) || 7; }
  function giftsCount() { var l = L(); return !!(l && l.config && l.config().giftsCount); }
  function urlOf(u) { return typeof u === 'string' ? u : (u && (u.url || u.href)) || ''; }

  function stateOf(cart) {
    var l = L(), s = { p: 0, b: 0, g: 0, bags: [], gifts: [], autoBags: [], autoGifts: [] };
    (cart.items || []).forEach(function (i) {
      var v = Number(i.variant_id);
      if (v === GIFT || i.handle === 'mystery-gift') { s.g += i.quantity; s.gifts.push(i); if (isAutoLine(i)) s.autoGifts.push(i); }
      else if (v === BAG || i.handle === 'wash-bag') { s.b += i.quantity; s.bags.push(i); if (isAutoLine(i)) s.autoBags.push(i); }
      else if (l && l.isPieceLine(i)) s.p += i.quantity;
    });
    s.bagOK = s.p >= bagAt();
    s.giftOK = s.p + (giftsCount() ? s.b : 0) >= giftAt();
    return s;
  }
  function isFree(it) { return !!(it.properties && (it.properties._bf_auto || it.properties._bf_free)); }
  function isAutoLine(i) { return !!(i.properties && (i.properties._bf_auto || i.properties._bf_free || i.properties._bf_set)); }
  function kind(it) {
    var id = Number(it.id);
    if (id === GIFT) return 'g';
    if (id === BAG) return 'b';
    var l = L();
    if ((l && l.isPiece(id)) || (it.properties && it.properties._bf_set)) return 'p';
    return 'o';
  }

  /* ---- message ---- */
  var st = document.createElement('style');
  st.textContent = '.bf26y-gg{position:fixed;left:50%;bottom:20px;transform:translateX(-50%);z-index:2147483000;max-width:calc(100vw - 32px);background:#fff;color:var(--rk-ink-1,#2B2F27);border:1px solid var(--rk-brown,#5E7249);border-radius:var(--rk-radius,2px);padding:12px 16px;font:400 15px/1.4 var(--rk-font-body,var(--font-body-family));box-shadow:0 4px 18px rgba(0,0,0,.15);display:flex;gap:12px;align-items:center;flex-wrap:wrap}.bf26y-gg a{color:var(--rk-brown,#5E7249);font-weight:600;text-decoration:underline;min-height:44px;display:inline-flex;align-items:center}html[data-gg-lock] .bf26a-satc{display:none!important}';
  (document.head || document.documentElement).appendChild(st);
  var msgT = 0;
  function say(text) {
    var d = document.querySelector('.bf26y-gg');
    if (!d) { d = document.createElement('div'); d.className = 'bf26y-gg'; d.setAttribute('role', 'status'); document.body.appendChild(d); }
    d.innerHTML = '';
    var s = document.createElement('span'); s.textContent = text; d.appendChild(s);
    var a = document.createElement('a'); a.href = '/pages/bundle-builder'; a.textContent = 'Build a bundle'; d.appendChild(a);
    clearTimeout(msgT); msgT = setTimeout(function () { if (d.parentNode) d.parentNode.removeChild(d); }, 7000);
  }
  function bagLabel() { return 'Free with ' + bagAt() + '+ pieces'; }
  function giftLabel() { return 'Free with ' + giftAt() + '+ pieces'; }

  /* ---- body parsing ---- */
  function fromForm(fd, isUSP) {
    var entries = [], keys = [];
    fd.forEach(function (v, k) { entries.push([k, v]); keys.push(k); });
    var multi = keys.some(function (k) { return /^items\[\d+\]\[id\]$/.test(k); });
    var items = [], rest = [];
    if (multi) {
      var map = {};
      entries.forEach(function (e) {
        var m = /^items\[(\d+)\]\[(id|quantity|properties)\](?:\[(.+)\])?$/.exec(e[0]);
        if (!m) { rest.push(e); return; }
        var it = map[m[1]] || (map[m[1]] = { properties: {} });
        if (m[2] === 'properties') it.properties[m[3]] = e[1]; else it[m[2]] = e[1];
      });
      Object.keys(map).sort(function (a, b) { return a - b; }).forEach(function (k) { items.push(map[k]); });
    } else {
      if (keys.indexOf('id') < 0) return null;
      var one = { properties: {} };
      entries.forEach(function (e) {
        var m = /^properties\[(.+)\]$/.exec(e[0]);
        if (e[0] === 'id') one.id = e[1]; else if (e[0] === 'quantity') one.quantity = e[1]; else if (m) one.properties[m[1]] = e[1]; else rest.push(e);
      });
      items.push(one);
    }
    return { items: items, build: function (keep) {
      var out = isUSP ? new URLSearchParams() : new FormData();
      rest.forEach(function (e) { out.append(e[0], e[1]); });
      keep.forEach(function (it, n) {
        var pre = multi ? 'items[' + n + '][' : '';
        var key = function (f) { return multi ? pre + f + ']' : f; };
        out.append(key('id'), it.id);
        if (it.quantity != null) out.append(key('quantity'), it.quantity);
        Object.keys(it.properties || {}).forEach(function (p) { out.append(multi ? pre + 'properties][' + p + ']' : 'properties[' + p + ']', it.properties[p]); });
      });
      return out;
    } };
  }
  function parse(body) {
    try {
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var j = JSON.parse(body), items = j.items || (j.id != null ? [j] : null);
          if (!items) return null;
          return { items: items, build: function (keep) { if (j.items) j.items = keep; else j = keep[0]; return JSON.stringify(j); } };
        }
        var p = fromForm(new URLSearchParams(body), true);
        if (!p) return null;
        var b0 = p.build; p.build = function (k) { return b0(k).toString(); };
        return p;
      }
      if (typeof FormData !== 'undefined' && body instanceof FormData) return fromForm(body, false);
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return fromForm(body, true);
    } catch (e) {}
    return null;
  }

  /* ---- 1 decision on an add ---- */
  function inspect(P) {
    return of('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var s = stateOf(cart), addP = 0, addB = 0;
      P.items.forEach(function (it) {
        var k = kind(it), q = Number(it.quantity) || 1;
        if (k === 'p') addP += q; else if (k === 'b' && !isFree(it)) addB += q;
      });
      var bagOK = s.p + addP >= bagAt();
      var giftOK = s.p + addP + (giftsCount() ? s.b + (bagOK ? addB : 0) : 0) >= giftAt();
      var dropped = '';
      var keep = P.items.filter(function (it) {
        if (isFree(it)) return true;
        var k = kind(it);
        if (k === 'b' && !bagOK) { dropped = dropped || 'b'; return false; }
        if (k === 'g' && !giftOK) { dropped = dropped || 'g'; return false; }
        return true;
      });
      if (!dropped) return { changed: false };
      var text = dropped === 'b' ? bagLabel() : giftLabel();
      if (!keep.length) return { refuse: true, text: text };
      return { changed: true, body: P.build(keep), text: text };
    });
  }
  function fake(text) {
    return JSON.stringify({ status: 422, message: text, description: 'This item is free with a bundle. ' + text + '.' });
  }

  /* ---- request tracking: the sync only runs once the cart is quiet ---- */
  var pending = 0, settledAt = 0, timer = 0;
  function kick() { clearTimeout(timer); timer = setTimeout(sync, Math.max(30, settledAt + QUIET - Date.now())); }
  function settle() { pending = Math.max(0, pending - 1); settledAt = Date.now(); drawn = {}; kick(); } // a new cart request: a sig drawn before may be stale again (A -> B -> A, or two carts with the same item_count.lines.total)
  function track(p) { pending++; p.then(settle, settle); return p; }
  /* F1 (29 Oct 2026): the caller of a cart add/change/update/clear does not get its response until the free-line sync for that cart has finished (the bag / gift add or
     remove is awaited, the drawer is re-rendered from that final cart). Before, the sync ran 250 ms after the caller had already drawn its own response, so for about 3 s
     the drawer said Unlocked while /cart.js had no bag (and a quick checkout lost the free shipping that needs the bag in the count). Other requests still in flight: the last one to settle syncs. */
  function after(p) {
    return p.then(function (r) {
      return flush().then(function () { return r; }, function () { return r; });
    });
  }

  /* ---- fetch ---- */
  window.fetch = function (u, o) {
    var url = urlOf(u), mut = MUT.test(url);
    try {
      if (!BUYABLE && ADD.test(url) && o && o.body != null) {
        var P = parse(o.body);
        if (P) {
          return after(track(inspect(P).then(function (r) {
            if (r.refuse) { say(r.text); return new Response(fake(r.text), { status: 422, headers: { 'Content-Type': 'application/json' } }); }
            if (r.changed) { say(r.text); o = Object.assign({}, o, { body: r.body }); }
            return of.call(window, u, o);
          }, function () { return of.call(window, u, o); })));
        }
      }
    } catch (e) {}
    var res = of.apply(this, arguments);
    return mut ? after(track(res)) : res;
  };

  /* ---- XHR ---- */
  try {
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__ggUrl = String(u); return xo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      var x = this;
      if (!x.__ggUrl || !MUT.test(x.__ggUrl)) return xs.apply(this, arguments);
      var done = false;
      pending++;
      x.addEventListener('loadend', function () { if (!done) { done = true; settle(); } });
      if (!BUYABLE && ADD.test(x.__ggUrl) && body != null) {
        var P = parse(body);
        if (P) {
          inspect(P).then(function (r) {
            if (r.refuse) {
              say(r.text);
              var t = fake(r.text);
              [['status', 422], ['readyState', 4], ['responseText', t], ['response', t], ['statusText', 'Unprocessable Entity']].forEach(function (p) { try { Object.defineProperty(x, p[0], { value: p[1], configurable: true }); } catch (e) {} });
              ['readystatechange', 'load', 'loadend'].forEach(function (n) { try { x.dispatchEvent(new Event(n)); } catch (e) {} });
              if (!done) { done = true; settle(); }
              return;
            }
            if (r.changed) say(r.text);
            xs.call(x, r.changed ? r.body : body);
          }, function () { xs.call(x, body); });
          return;
        }
      }
      return xs.apply(this, arguments);
    };
  } catch (e) {}

  /* ---- 2 product page buttons ---- */
  var orig = new WeakMap(), tp = 0;
  function earnedNow() {
    var l = L(), c = l && l.getCart && l.getCart();
    if (!c) return null;
    var s = stateOf(c);
    return handle === 'wash-bag' ? s.bagOK : s.giftOK;
  }
  function setText(btn, label) {
    var w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT), n, t = null;
    while ((n = w.nextNode())) { if (n.nodeValue.trim()) { t = n; break; } }
    if (!t) return;
    var rec = orig.get(btn);
    if (label) { if (!rec) orig.set(btn, { node: t, text: btn.getAttribute('data-gg-orig') || t.nodeValue }); if (t.nodeValue !== label) t.nodeValue = label; }
    else if (rec) { rec.node.nodeValue = rec.text; orig.delete(btn); }
    else if (btn.hasAttribute('data-gg-orig')) { t.nodeValue = btn.getAttribute('data-gg-orig'); } /* locked on the server (buy-buttons.liquid) */
  }
  function pdp() {
    if (handle !== 'wash-bag' && handle !== 'mystery-gift') return;
    var ok = BUYABLE ? true : earnedNow(); if (ok === null) return; /* BUYABLE: only undoes a lock the server printed */
    var label = handle === 'wash-bag' ? bagLabel() : giftLabel();
    if (ok) document.documentElement.removeAttribute('data-gg-lock'); else document.documentElement.setAttribute('data-gg-lock', '1');
    document.querySelectorAll('product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"], .shopify-payment-button button').forEach(function (b) {
      if (b.closest('cart-drawer, #CartDrawer')) return;
      if (!ok) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); b.setAttribute('data-gg', '1'); setText(b, label); }
      else if (b.getAttribute('data-gg')) { b.disabled = false; b.removeAttribute('aria-disabled'); b.removeAttribute('data-gg'); setText(b, null); }
    });
    document.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach(function (w) { w.style.display = ok ? '' : 'none'; });
  }

  /* ---- 3a re-render (Section Rendering API): the drawer, the header bubble and, on /cart, the cart sections. Never a page reload. ---- */
  function sectionIds() {
    var ids = [], it = document.getElementById('main-cart-items'), ft = document.getElementById('main-cart-footer'), rw = document.querySelector('[data-rk-section]');
    if (it && it.getAttribute('data-id')) ids.push(it.getAttribute('data-id'));
    if (ft && ft.getAttribute('data-id')) ids.push(ft.getAttribute('data-id'));
    if (rw) ids.push(rw.getAttribute('data-rk-section'));
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
    return ids.slice(0, 5); // the API renders at most 5 sections per request
  }
  /* 26 Oct 2026 (Alexander, Microsoft Clarity: frustrated taps on Check out, View cart and the X in the phone drawer). The free wash bag lands about 1.5 s
     after the drawer opens (3 Pack added) and this render swapped the whole panel, so a tap that started on the old button ended on a new one and did
     nothing. (1) A render waits while a finger or the mouse is down in the drawer and 350 ms after it lifts (at most 2 s); (2) the close button, View cart
     and Check out keep their own element when the new HTML has the same one, so a tap in flight still lands. */
  var touching = false, touchUntil = 0, KEEP = ['.drawer__close', '.rk-dh__view', '#CartDrawer-Checkout'];
  document.addEventListener('pointerdown', function (e) { if (e.target && e.target.closest && e.target.closest('cart-drawer')) { touching = true; touchUntil = Date.now() + 2000; } }, true);
  function lift() { if (touching) { touching = false; touchUntil = Date.now() + 350; } }
  document.addEventListener('pointerup', lift, true);
  document.addEventListener('pointercancel', lift, true);
  function sameEl(o, n) {
    return o.tagName === n.tagName && !o.classList.contains('loading') && o.disabled === n.disabled &&
      (o.getAttribute('href') || '') === (n.getAttribute('href') || '') && o.textContent.replace(/\s+/g, ' ').trim() === n.textContent.replace(/\s+/g, ' ').trim();
  }
  function render(S, waited) {
    if (!S) return;
    waited = waited || 0;
    if ((touching || Date.now() < touchUntil) && waited < 2000) { setTimeout(function () { render(S, waited + 120); }, 120); return; }
    var DP = new DOMParser();
    function doc(id) { return id && S[id] ? DP.parseFromString(S[id], 'text/html') : null; }
    try {
      var d = doc('cart-drawer');
      if (d) {
        var ni = d.querySelector('#CartDrawer .drawer__inner'), oi = document.querySelector('#CartDrawer .drawer__inner');
        if (ni && oi) { // the inner panel only: the overlay keeps the theme's click-to-close listener
          var ob = oi.querySelector('.cart-drawer__body'), top = ob ? ob.scrollTop : 0, focus = oi.contains(document.activeElement);
          var kept = KEEP.map(function (s) { var o = oi.querySelector(s), n = ni.querySelector(s); return o && n && sameEl(o, n) ? o : null; });
          oi.innerHTML = ni.innerHTML;
          KEEP.forEach(function (s, k) { var n = kept[k] && oi.querySelector(s); if (n) n.replaceWith(kept[k]); });
          var nb = oi.querySelector('.cart-drawer__body'); if (nb && top) nb.scrollTop = top;
          if (focus) { try { oi.focus({ preventScroll: true }); } catch (e) {} }
        } else {
          var nw = d.getElementById('CartDrawer'), old = document.getElementById('CartDrawer');
          if (nw && old) old.innerHTML = nw.innerHTML;
        }
        var nc = d.querySelector('cart-drawer'), oc = document.querySelector('cart-drawer');
        if (nc && oc) oc.classList.toggle('is-empty', nc.classList.contains('is-empty'));
      }
      var bd = doc('cart-icon-bubble'), ib = document.getElementById('cart-icon-bubble');
      if (bd && ib) { var bs = bd.querySelector('.shopify-section'); if (bs) ib.innerHTML = bs.innerHTML; }
      [['main-cart-items', 'cart-items'], ['main-cart-footer', '#main-cart-footer']].forEach(function (p) {
        var host = document.getElementById(p[0]), nd = doc(host && host.getAttribute('data-id'));
        if (!nd) return;
        var nh = nd.getElementById(p[0]), a = host.querySelector('.js-contents'), b = nh && nh.querySelector('.js-contents');
        if (a && b) a.innerHTML = b.innerHTML;
        var ow = document.querySelector(p[1]), nw2 = nd.querySelector(p[1]);
        if (ow && nw2) ow.classList.toggle('is-empty', nw2.classList.contains('is-empty'));
      });
      var rw = document.querySelector('[data-rk-section]'), rid = rw && rw.getAttribute('data-rk-section'), rd = doc(rid);
      if (rd) {
        var os = document.getElementById('shopify-section-' + rid), ns = rd.getElementById('shopify-section-' + rid);
        if (os && ns) os.innerHTML = ns.innerHTML;
      }
    } catch (e) {}
  }

  /* ---- 3b cart sync ---- */
  var KEY = 'rk-gg-v1', mem = { fail: {}, declined: {} };
  function guard() { try { var g = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (g && g.fail && g.declined) return g; } catch (e) {} return mem; }
  function keep(g) { mem = g; try { sessionStorage.setItem(KEY, JSON.stringify(g)); } catch (e) {} }

  var running = false, again = false, posts = 0, prev = null, ours = {}, drawn = {};
  function post(url, body, kinds) {
    posts++;
    body.sections = sectionIds().join(',');
    body.sections_url = path;
    function failed() { var g = guard(); kinds.forEach(function (k) { g.fail[k] = (g.fail[k] || 0) + 1; }); keep(g); return false; }
    return of(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok && !(j && +j.status >= 400), j: j }; }); })
      .then(function (res) {
        settledAt = Date.now();
        if (!res.ok) return failed();
        var g = guard(); kinds.forEach(function (k) { delete g.fail[k]; }); keep(g);
        render(res.j && res.j.sections);
        return true;
      }, failed);
  }
  function declined(s, g) {
    if (!ALLOW_DECLINE) { delete g.declined.b; delete g.declined.g; return; }
    // a free line that was in the cart and is gone while still earned, and we did not remove it: the shopper removed it, so it is not added back at this paid count
    if (prev) {
      if (prev.bags.length && !s.bags.length && s.bagOK && !prev.bags.some(function (i) { return ours[i.key]; })) g.declined.b = s.p;
      if (prev.gifts.length && !s.gifts.length && s.giftOK && !prev.gifts.some(function (i) { return ours[i.key]; })) g.declined.g = s.p;
    }
    if (g.declined.b != null && g.declined.b !== s.p) delete g.declined.b;
    if (g.declined.g != null && g.declined.g !== s.p) delete g.declined.g;
  }
  function plan(s, g) {
    var upd = {}, adds = [], kinds = [], n = 0;
    // r55 (BUYABLE): bought lines are never touched; below the rung only the free lines go; from the rung the shopper's own line counts as the one bag / gift.
    function trim(lines, earned) {
      var auto = lines.filter(isAutoLine), manual = lines.filter(function (i) { return !isAutoLine(i); });
      if (!earned) { (BUYABLE ? auto : lines).forEach(function (i) { upd[i.key] = 0; ours[i.key] = 1; n++; }); return; }
      if (auto.length && (manual.length || auto.length > 1 || auto[0].quantity > 1)) {
        auto.forEach(function (i, k) { var q = !manual.length && k === 0 ? 1 : 0; if (q !== i.quantity) { upd[i.key] = q; if (!q) ours[i.key] = 1; n++; } });
      }
    }
    trim(s.bags, s.bagOK);
    trim(s.gifts, s.giftOK);
    var haveBag = s.bags.length, haveGift = s.gifts.length;
    if (s.bagOK && !haveBag && g.declined.b == null && (g.fail.b || 0) < MAX_FAIL) { adds.push({ id: BAG, quantity: 1, properties: { _bf_auto: '1', _bf_free: '1' } }); kinds.push('b'); }
    if (s.giftOK && !haveGift && g.declined.g == null && (g.fail.g || 0) < MAX_FAIL) { adds.push({ id: GIFT, quantity: 1, properties: { _bf_auto: '1', _bf_free: '1' } }); kinds.push('g'); }
    return { upd: n && (g.fail.u || 0) < MAX_FAIL ? upd : null, adds: adds, kinds: kinds };
  }
  // which sections show an older cart than /cart.js. On /cart the drawer is only checked while it is open, so a quantity change there never re-renders twice.
  function outOfDate(cart) {
    var l = L(), sig = l && l.sig ? l.sig(cart) : '', ids = [];
    if (drawn[sig]) return ids;
    var cs = document.querySelector('#main-cart-items [data-rk-cart-sig]'), dw = document.querySelector('cart-drawer');
    var ds = (!cs || (dw && dw.classList.contains('active'))) && document.querySelector('#CartDrawer [data-rk-cart-sig]');
    if (cs && cs.getAttribute('data-rk-cart-sig') !== sig) ids = sectionIds().filter(function (id) { return id !== 'cart-drawer'; });
    if (ds && ds.getAttribute('data-rk-cart-sig') !== sig) { if (ids.indexOf('cart-icon-bubble') < 0) ids.push('cart-icon-bubble'); ids.push('cart-drawer'); }
    if (ids.length) drawn[sig] = 1;
    return ids;
  }
  function act(cart) {
    var s = stateOf(cart), g = guard();
    declined(s, g); keep(g);
    prev = s;
    var p = BUILDER ? { upd: null, adds: [], kinds: [] } : plan(s, g), chain = Promise.resolve(false);
    if (p.upd || p.adds.length) {
      if (posts >= MAX_POSTS) { try { console.warn('rk giftguard: sync post limit reached on this page'); } catch (e) {} return chain; }
      if (p.upd) chain = chain.then(function () { return post('/cart/update.js', { updates: p.upd }, ['u']); });
      if (p.adds.length) chain = chain.then(function () { return post('/cart/add.js', { items: p.adds }, p.kinds); });
      return chain.then(function (ok) { if (ok) kick(); return ok; });
    }
    // nothing to change: make sure the screen shows this cart (a second add the theme did not render, or a script that changed the cart without a re-render)
    var stale = outOfDate(cart);
    if (stale.length) {
      return of(path + '?sections=' + stale.slice(0, 5).join(','), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).then(render).catch(noop);
    }
    return chain;
  }
  var runP = Promise.resolve();
  function flush() {
    clearTimeout(timer);
    if (pending > 0) return Promise.resolve();
    var l = L();
    if (!l || !l.isPieceLine || !l.bagAt) return Promise.resolve();
    running = true;
    runP = runP.then(function () {
      return of('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(function (cart) { if (pending > 0) { again = true; return; } return act(cart); })
        .catch(noop)
        .then(function () { running = false; });
    });
    return runP;
  }
  function sync() {
    if (running) { again = true; return; }
    if (pending > 0) return; // the last settle kicks the next run
    if (settledAt + QUIET - Date.now() > 0) { kick(); return; }
    var l = L();
    if (!l || !l.isPieceLine || !l.bagAt) { timer = setTimeout(sync, 300); return; }
    flush().then(function () { if (again) { again = false; kick(); } });
  }

  window.RKCart = { render: render, sync: kick, sectionIds: sectionIds };

  (function hook() {
    var l = L();
    if (!l || !l.onUpdate) return setTimeout(hook, 300);
    l.onUpdate(function () { kick(); clearTimeout(tp); tp = setTimeout(pdp, 300); });
    pdp();
  })();
  window.addEventListener('pageshow', function (e) { if (e.persisted) kick(); });
  new MutationObserver(function () { if (handle === 'wash-bag' || handle === 'mystery-gift') { clearTimeout(tp); tp = setTimeout(pdp, 250); } }).observe(document.documentElement, { childList: true, subtree: true });
})();
